<template>
  <v-container fluid full-height grit-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllGJ('printAllGeneralJournal')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllGJ()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  class="mr-2"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  class="mr-2"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="this.user.role.roleName != 'BRANCH_ADMIN'">
              <shop-autocomplete
                :param="Number(queryParams.shopId)"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="ledgerNo"
                label="Journal No"
                type="text"
                class="mr-2"
                v-model="queryParams.ledgerNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.status"
                :items="statusList"
                color="blue-grey lighten-2"
                label="Choose Status..."
                item-text="label"
                item-value="value"
                class="mr-2"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="operationSettingList"
                label="Operation Setting"
                item-text="name"
                item-value="id"
                v-model="queryParams.operationSettingId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Ledger By"
                v-model="queryParams.ledgerBy"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="invoiceNo"
                label="Invoice No"
                type="text"
                class="mr-2"
                v-model="queryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="chequeNo"
                label="Cheque No"
                type="text"
                class="mr-2"
                v-model="queryParams.chequeNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="reference"
                label="Reference"
                type="text"
                class="mr-2"
                v-model="queryParams.reference"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                class="mr-2"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="generalLedgerList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn
                    flat
                    icon
                    color="blue lighten-2"
                    @click="onEdit(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td>{{ props.item.status }}</td>
                <td>
                  {{ props.item.ledgerDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.ledgerNo }}</td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.invoiceNo }}</td>
                <td>{{ props.item.chequeNo }}</td>
                <td>{{ props.item.reference }}</td>
                <td>{{ props.item.operationSettingName }}</td>
                <td>{{ props.item.shopCode }}</td>
                <td>{{ props.item.totalAmount | decFormat(6) }}</td>
                <td>{{ props.item.ledgerByName }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.generalLedgerDetailList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.code }}</td>
                      <td class="text-xs">
                        {{ subprops.item.accountName }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.accountType }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.amount | decFormat(6) }}
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all general ledger-->
    <div
      id="printAllGeneralJournal"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px; font-weight: bold">
          {{ shopCode }}
        </p>
      </div>
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">Ledger Entrys</p>
      </div>
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">
          From [{{ fDate }}] to [{{ tDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Journal No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Description
              </th>
              <th style="border: 1px solid black; text-align: center">
                Shop Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Debit Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Credit Amount
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(generalJournal, index) in allGeneralJournalList"
            :key="index"
          >
            <tr
              v-for="(item, i) in generalJournal.generalLedgerPrintDTOList"
              :key="i"
            >
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="generalJournal.generalLedgerPrintDTOList.length"
              >
                {{ item.ledgerDateInMilliSeconds | formatMsDate }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="generalJournal.generalLedgerPrintDTOList.length"
              >
                {{ item.ledgerNo }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="generalJournal.generalLedgerPrintDTOList.length"
              >
                {{ item.description }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="generalJournal.generalLedgerPrintDTOList.length"
              >
                {{ item.shopCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.code }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.accountName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                <span v-if="item.accountType == 'DEBIT'">{{
                  item.amount | decFormat(6)
                }}</span
                ><span v-else></span>
              </td>
              <td style="border: 1px solid black; text-align: right">
                <span v-if="item.accountType == 'CREDIT'">{{
                  item.amount | decFormat(6)
                }}</span
                ><span v-else></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import ShopAutocomplete from "../templates/ShopAutocomplete.vue";
import { commonService } from "../../services/common-service";
import { generalLedgerService } from "../../services/general-ledger-service";
import { operationSettingService } from "../../services/operation-setting-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "GeneralLedgerList",
  components: { ShopAutocomplete },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Ledger Entry",
        disabled: true,
      },
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Draft", value: "DRAFT" },
      { label: "Posted", value: "POSTED" },
      { label: "Cancel", value: "CANCEL" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      ledgerNo: "",
      status: "",
      type: "JOURNAL",
      updateUserId: "",
      operationSettingId: "",
      ledgerBy: "",
      invoiceNo: "",
      chequeNo: "",
      reference: "",
      description: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", sortable: false },
      { text: "Date", align: "left", value: "ledgerDate" },
      { text: "Journal No", align: "left", value: "ledgerNo" },
      { text: "Description", value: "description" },
      { text: "Invoice No", value: "invoiceNo" },
      { text: "Cheque No", value: "chequeNo" },
      { text: "Reference", value: "reference" },
      { text: "Operation Setting", sortable: false },
      { text: "Shop Code", value: "shopCode" },
      { text: "Total Amount", sortable: false },
      { text: "Ledger By", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    subHeaders: [
      { text: "Code", align: "left", value: "code" },
      { text: "Account Name", align: "left", value: "accountName" },
      { text: "Type", align: "left", value: "accountType" },
      { text: "Amount", align: "left", value: "amount" },
    ],
    rowsPerPageItems: [25, 50, 100],
    generalLedgerList: [],
    operationSettingList: [],
    totalRows: 0,
    shopList: [],
    decimalFormat: "",
    showListLoading: false,
    fDate: "",
    tDate: "",
    allGeneralJournalList: [],
    shopCode: "",
  }),

  created() {
    if (this.user.role.roleName == "ACCOUNTANT") {
      this.queryParams.updateUserId = this.user.id;
    }
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shop.id;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.ledgerNo) {
      this.queryParams.ledgerNo = this.$route.query.ledgerNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.operationSettingId) {
      this.queryParams.operationSettingId =
        Number(this.$route.query.operationSettingId);
    }
    if (this.$route.query.ledgerBy) {
      this.queryParams.ledgerBy = Number(this.$route.query.ledgerBy);
    }
    if (this.$route.query.invoiceNo) {
      this.queryParams.invoiceNo = this.$route.query.invoiceNo;
    }
    if (this.$route.query.chequeNo) {
      this.queryParams.chequeNo = this.$route.query.chequeNo;
    }
    if (this.$route.query.reference) {
      this.queryParams.reference = this.$route.query.reference;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getGeneralLedgerList();
    this.getOperationSettingList();
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  watch: {
    pagination: {
      handler() {
        this.getGeneralLedgerList();
      },
      deep: true,
    },
  },

  methods: {
    onRegister() {
      this.$router.push("/general-journal/new");
    },
    getGeneralLedgerList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      generalLedgerService
        .getAllGeneralLedger(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.generalLedgerList = res.data.generalLedgerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onEdit(generalLedger) {
      // go to details page
      this.$router.push("/general-journal/" + generalLedger.id);
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        this.queryParams.shopId = this.user.shopId;
      }
      this.$router.replace({
        name: "general-journals",
        query: this.queryParams,
      });
      this.getGeneralLedgerList();
    },

    setShop(obj) {
      this.shopCode = obj.shopCode;
      this.queryParams.shopId = obj.shopId;
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    exportAllGJ() {
      this.buttonLoading = true;
      generalLedgerService
        .getGeneralLedgerExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },

    printAllGJ(divName) {
      this.buttonLoading = true;
      generalLedgerService
        .getAllGeneralLedgerList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allGeneralJournalList = res.data;
            this.fDate = commonService.formatDate(
              this.queryParams.fromDate,
              "DD-MM-YYYY"
            );
            this.tDate = commonService.formatDate(
              this.queryParams.toDate,
              "DD-MM-YYYY"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 1000);
          this.buttonLoading = false;
        });
    },
    getOperationSettingList() {
      operationSettingService
        .getAllOperationSettings()
        .then((res) => {
          this.operationSettingList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
